import { Key } from 'react';

export class PaginationConfig {
  public constructor(
    public current: number = 1,
    public pageSize: number = 10,
  ) {}
}

export enum SortDirection {
  Ascending = 'ASC',
  Descending = 'DESC',
}

export class SortConfig {
  constructor(public field: string, public direction: SortDirection) {}
}

export class SearchRequest {
  public constructor(
    public paging: PaginationConfig,
    public sortBy: SortConfig[] = [],
    public filter: Record<string, (Key | boolean)[] | null> = {},
  ) {}
}

export type PaginationConfigWithCount = PaginationConfig & {
  total?: number;
};

export class SearchResponse<TModel> {
  public constructor(
    public paging: PaginationConfigWithCount,
    public sortBy: SortConfig[],
    public data: TModel[],
  ) {}
}

export class ProgramSummaryStats {
  public constructor(
    public submmited: number,
    public inprogress: number,
    public drafts: number,
    public completed: number,
    public failed: number,
    public active_templates: number,
    public archived: number,
  ) {}
}
